import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 34,
    color: '#D6246E',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    marginBottom: 15,
    marginTop: -30,
  },
  textBenefits: {
    fontSize: 14,
    color: '#636161',
    fontWeight: 'bold',
    fontFamily: 'lato',
    whiteSpace: 'nowrap',
    textAlign: 'initial',
    margin: '5px 0px 5px 10px',
  },
  textInfo: {
    color: '#424242',
    fontFamily: 'Lato',
    fontSize: '18',
  },
  buttonWhite: {
    borderRadius: 35,
    border: '1px solid #9E9E9E',
    color: '#616161',
    padding: '10px 30px',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    textTransform: 'none',

    '&:hover': {
      border: '1px solid #7833FF',
      color: '#7833FF',
    },
  },
  buttonPurple: {
    borderRadius: 35,
    padding: '10px 30px',
    backgroundColor: '#7833FF',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Lato',
    fontWeight: 'bold',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
}));
